import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import JobList from 'views/scenes/career/job_list/JobList';
import JOB_SOURCES from 'views/scenes/career/job_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomCareerDashboard = () => {
  const jobReadFlag = useFlag(FLAGS.JOB_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (jobReadFlag.isLoading || jobReadFlag.isEnabled) return;

    navigate('/career', {replace: true});
  }, [jobReadFlag.isEnabled, jobReadFlag.isLoading, navigate]);

  if (jobReadFlag.isLoading || !jobReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Job Listings (Loom)</title>
      </Helmet>
      <JobList
        jobSource={JOB_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomCareerDashboard;
